<template>
  <ResumeCard
    :resume="resume"
    :with-footer="false"
  >
    <template #body>
      <ContentSection v-if="skills">
        <InlineList
          :items="skills"
          v-slot="{ item }"
        >
          <BasicLink
            v-if="item.href"
            :href="item.href"
            :title="item.title"
            appearance="dark"
          />
          <span
            v-else
            v-text="item.title"
          />
        </InlineList>
      </ContentSection>

      <ContentSection
        v-if="resume.age"
        title="Возраст"
      >
        {{ resume.age.title }}
      </ContentSection>

      <ContentSection
        v-if="resume.location"
        title="Город"
      >
        {{ resume.location.title }}
      </ContentSection>

      <ContentSection
        v-if="companies"
        title="Место работы"
      >
        <InlineList
          :items="companies"
          v-slot="{ item }"
        >
          <BasicLink
            v-if="item.href"
            :href="item.href"
            :title="item.title"
            appearance="dark"
          />
          <span
            v-else
            v-text="item.title"
          />
        </InlineList>
      </ContentSection>
      <ContentSection
        v-if="investedHubs"
        title="Пишет в хабы"
      >
        <InlineList
          :items="investedHubs"
          v-slot="{ item }"
        >
          <RankedItem
            :item="item"
            :with-rank="false"
            target="_blank"
            rel="noreferrer"
          />
        </InlineList>
      </ContentSection>
      <ContentSection
        v-if="subscribedHubs"
        title="Подписан на хабы"
      >
        <InlineList
          :items="subscribedHubs"
          v-slot="{ item }"
        >
          <RankedItem
            :item="item"
            :with-rank="false"
            target="_blank"
          />
        </InlineList>
      </ContentSection>
      <ContentSection v-if="communities">
        <CommunityInlineList :communities="communities" />
      </ContentSection>
    </template>
  </ResumeCard>
</template>

<script>
  import BasicLink from 'src/components/BasicLink/BasicLink.vue';
  import CommunityInlineList from 'src/components/CommunityInlineList/CommunityInlineList.vue';
  import InlineList from 'src/components/InlineList/InlineList.vue';
  import RankedItem from 'src/components/RankedItem/RankedItem.vue';
  import ResumeCard from 'src/components/resumes/ResumeCard/ResumeCard.vue';
  import ContentSection from 'src/components/sections/ContentSection/ContentSection.vue';

  export default {
    name: 'HabrResumeCard',
    components: { RankedItem, CommunityInlineList, BasicLink, InlineList, ContentSection, ResumeCard },
    props: {
      resume: {
        type: Object,
        required: true,
      },
    },
    methods: {
      optionalList(list) {
        if (!list || !list.length) {
          return null;
        }

        return list;
      }
    },
    computed: {
      skills() {
        return this.optionalList(this.resume.skills);
      },
      companies() {
        return this.optionalList(this.resume.companies);
      },
      investedHubs() {
        return this.optionalList(this.resume.habr.activity?.items);
      },
      subscribedHubs() {
        return this.optionalList(this.resume.habr.subscriptions?.items);
      },
      communities() {
        return this.optionalList(this.resume.communities);
      },
    }
  };
</script>
